/**
 * Product Mix Report Filters Component
 * @see Sprint - Rapport Product Mix
 *
 * Simple date range picker (dateFrom/dateTo), default = current month.
 * Same pattern as PurchaseSummaryFilters.
 */

import { DatePicker } from '@/components/ui';
import type { DateRange } from '@/components/ui';

interface ProductMixFiltersProps {
  dateRange: DateRange;
  onDateRangeChange: (range: DateRange) => void;
}

export function ProductMixFilters({
  dateRange,
  onDateRangeChange,
}: ProductMixFiltersProps) {
  return (
    <div className="flex flex-wrap items-end gap-4">
      {/* Date range picker */}
      <div className="w-80">
        <label className="block text-sm font-medium text-neutral-700 mb-1">
          Periode
        </label>
        <DatePicker
          maxDate={new Date()}
          value={dateRange}
          onChange={onDateRangeChange}
          placeholder="Selectionner une periode"
        />
      </div>
    </div>
  );
}
